<template>
  <Loading v-if="!skeleton.homeLoaded" page="home" />
  <div v-show="skeleton.homeLoaded"  :class="{ 'fade-in': skeleton.homeLoaded }">
    <header-middle />
    <div class="container">
      <banner-temp mode="Home1" />
    </div>
    <direct-store />
    <offers-tabs />
    <div class="container">
      <banner-temp mode="Home2" />
    </div>
    <footer-template />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import HeaderMiddle from "../section/header/header.vue";
import BannerTemp from "../section/item/BannerTemp.vue";
import DirectStore from "../section/item/directStore.vue";
import OffersTabs from "../section/pages/Home/arrivals.vue";
import FooterTemplate from "../section/footer/footer.vue";
import Loading from "../section/item/loading.vue";
import { useSkeleton } from "@/store/skeleton";
let route = useRoute();
const skeleton = useSkeleton();
let routeName = route.name;
if (routeName == "Invite") {
  // کد پیگیری
  document.getElementById("mobileModalBTN").click();
} else if (routeName == "Poll") {
  // نظرسنجی
  document.getElementById("pollModalBTN").click();
} else if (routeName == "Track") {
  // پیگیری
  if (document.getElementById("emptyBasketBTN")) {
    document.getElementById("emptyBasketBTN").click();
  }
  document.getElementById("trackingModalBTN").click();
} else if (routeName == "Map") {
  // مپ در آدرس سبد خرید
  document.getElementById("mapModalBTN").click();
}
</script>
